module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg",
      "width": "4%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Chapter01"
    }
  }, [_vm._v("THE ELVES AND THE SHOEMAKER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Brothers Grimm • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Chapter02"
    }
  }, [_vm._v("AFTER CHRISTMAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hermann Hesse • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Chapter03"
    }
  }, [_vm._v("BERLIN AT CHRISTMASTIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heinrich Heine • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter04"
    }
  }, [_vm._v("CHRISTMAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kurt Tucholsky • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter05"
    }
  }, [_vm._v("INTERVIEW WITH SANTA CLAUS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Erich Kästner • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SEPARATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ilse Frapan • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVERY YEAR ONCE AGAIN—THE CLIENT GIFT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Martin Suter • Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CHRISTMAS BOX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Johann Wolfgang von Goethe • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN THE OUTER SUBURBS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Stamm • Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADVENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rainer Maria Rilke • Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS SHOPPING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthur Schnitzler • Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS WITH THE BUDDENBROOKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas Mann • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS NOT JUST ONCE A YEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heinrich Böll • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON CHRISTMAS EVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Helene Stökl • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NUTCRACKER AND THE KING OF MICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("E. T. A. Hoffmann • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS IN COCHINCHINA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Joseph Roth • Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS EVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Rosegger • Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARTIN’S CHRISTMAS WISH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Erich Kästner • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LOAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfdietrich Schnurre • Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O TANNENBAUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ernst Anschütz • Germany")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3c99e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Contents.vue
// module id = 66
// module chunks = 0